import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ae0527f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "complete-day" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "complete-day__content" }
const _hoisted_5 = { class: "grid grid-cols-4 gap-5 items-start mb-3" }
const _hoisted_6 = { class: "grid grid-cols-4 gap-5 items-start mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = { class: "w-full flex items-center justify-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-center select-none pb-5"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 mt-1" }, "Загрузка ...", -1))
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "При получении списка произошла ошибка", -1))
const _hoisted_16 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_17 = {
  key: 1,
  class: "content__table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_report_row = _resolveComponent("report-row")!
  const _component_report_info_row = _resolveComponent("report-info-row")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.close_day_modal.is_opened)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          "with-cancel-button": false,
          title: "Закрытие дня курьера",
          onSubmit: _ctx.closeCloseDayModal,
          onCancel: _ctx.closeCloseDayModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, "Курьер " + _toDisplayString(_ctx.close_day_modal.courier) + " еще не выполнил все условия:", 1),
            _createElementVNode("div", _hoisted_2, [
              (_ctx.close_day_modal.undelivered_invoices.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.close_day_modal.undelivered_invoices, (message) => {
                    return (_openBlock(), _createElementBlock("div", { key: message }, _toDisplayString(message), 1))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, "Все накладные доставлены"))
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Завершение дня" }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        class: "content__header",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFromDateChange && _ctx.onFromDateChange(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_new_input, {
            type: "date",
            placeholder: "Выберите дату",
            value: _ctx.filters.fromDate,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.fromDate) = $event)),
            "is-invalid": _ctx.filters$.fromDate.$error,
            "validation-errors": _ctx.filters$.fromDate.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_new_input, {
            type: "date",
            placeholder: "Выберите дату",
            value: _ctx.filters.toDate,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.toDate) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_new_select, {
            "can-deselect": "",
            value: _ctx.filters.hasReturn,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.hasReturn) = $event)),
            placeholder: "Возврат выдачи",
            options: _ctx.OPTIONS,
            class: "small full"
          }, null, 8, ["value", "options"]),
          _createVNode(_component_new_select, {
            "can-deselect": "",
            value: _ctx.filters.hasCash,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.hasCash) = $event)),
            placeholder: "Наличка",
            options: _ctx.OPTIONS,
            class: "small full"
          }, null, 8, ["value", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_new_select, {
            "can-deselect": "",
            value: _ctx.filters.hasCodPayment,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.hasCodPayment) = $event)),
            placeholder: "Налож платеж",
            options: _ctx.OPTIONS,
            class: "small full"
          }, null, 8, ["value", "options"]),
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_new_button, {
              class: "NewButton--reset h-full",
              onClick: _ctx.resetFilters
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Сбросить ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_new_button, {
              class: "NewButton--search",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(" Поиск ")
              ]),
              _: 1
            })
          ])
        ])
      ], 32),
      (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.reports.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary mr-2" }),
                  _hoisted_13
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_new_button, {
                      class: "NewButton--outline mt-2",
                      onClick: _ctx.onFromDateChange
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Обновить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_ctx.state.reports.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Список пуст"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_new_table, {
              columns: _ctx.COLUMNS,
              "nested-rows": _ctx.state.reports,
              "expanded-rows": _ctx.state.expanded_reports,
              "nested-rows-expand-key": "info"
            }, {
              "nested-td": _withCtx(({ column, row }) => [
                _createVNode(_component_report_row, {
                  column: column,
                  row: row,
                  expanded: _ctx.isReportExpanded(row.id),
                  onToggle: _ctx.toggleReport
                }, null, 8, ["column", "row", "expanded", "onToggle"])
              ]),
              "nested-row-td": _withCtx(({ column, parentrow, row, parentindex, rowindex }) => [
                _createVNode(_component_report_info_row, {
                  column: column,
                  row: row,
                  index: rowindex,
                  "parent-index": parentindex,
                  "parent-row": parentrow,
                  "date-filter": _ctx.filters.fromDate,
                  onClosed: _ctx.onDayClosed
                }, null, 8, ["column", "row", "index", "parent-index", "parent-row", "date-filter", "onClosed"])
              ]),
              _: 1
            }, 8, ["columns", "nested-rows", "expanded-rows"])
          ]))
    ])
  ]))
}